export const fontfamilylist=[
	{ value: 'ABeeZee', label: 'ABeeZee' },
	{ value: 'Abel', label: 'Abel' },
	{ value: 'Abril Fatface', label: 'Abril Fatface' },
	{ value: 'Acme', label: 'Acme' },
	{ value: 'Alata', label: 'Alata' },
	{ value: 'Alegreya', label: 'Alegreya' },
	{ value: 'Alegreya Sans', label: 'Alegreya Sans' },
	{ value: 'Alfa Slab One', label: 'Alfa Slab One' },
	{ value: 'Amatic SC', label: 'Amatic SC' },
	{ value: 'Amiri', label: 'Amiri' },
	{ value: 'Antic Slab', label: 'Antic Slab' },
	{ value: 'Anton', label: 'Anton' },
	{ value: 'Archivo', label: 'Archivo' },
	{ value: 'Archivo Black', label: 'Archivo Black' },
	{ value: 'Archivo Narrow', label: 'Archivo Narrow' },
	{ value: 'Arimo', label: 'Arimo' },
	{ value: 'Arvo', label: 'Arvo' },
	{ value: 'Asap', label: 'Asap' },
	{ value: 'Asap Condensed', label: 'Asap Condensed' },
	{ value: 'Assistant', label: 'Assistant' },
	{ value: 'Baloo 2', label: 'Baloo 2' },
	{ value: 'Barlow', label: 'Barlow' },
	{ value: 'Barlow Condensed', label: 'Barlow Condensed' },
	{ value: 'Barlow Semi Condensed', label: 'Barlow Semi Condensed' },
	{ value: 'Bebas Neue', label: 'Bebas Neue' },
	{ value: 'Bitter', label: 'Bitter' },
	{ value: 'Bree Serif', label: 'Bree Serif' },
	{ value: 'Cabin', label: 'Cabin' },
	{ value: 'Cairo', label: 'Cairo' },
	{ value: 'Cardo', label: 'Cardo' },
	{ value: 'Catamaran', label: 'Catamaran' },
	{ value: 'Caveat', label: 'Caveat' },
	{ value: 'Chakra Petch', label: 'Chakra Petch' },
	{ value: 'Changa', label: 'Changa' },
	{ value: 'Cinzel', label: 'Cinzel' },
	{ value: 'Comfortaa', label: 'Comfortaa' },
	{ value: 'Concert One', label: 'Concert One' },
	{ value: 'Cookie', label: 'Cookie' },
	{ value: 'Cormorant', label: 'Cormorant' },
	{ value: 'Cormorant Garamond', label: 'Cormorant Garamond' },
	{ value: 'Courgette', label: 'Courgette' },
	{ value: 'Covered By Your Grace', label: 'Covered By Your Grace' },
	{ value: 'Crete Round', label: 'Crete Round' },
	{ value: 'Crimson Text', label: 'Crimson Text' },
	{ value: 'Dancing Script', label: 'Dancing Script' },
	{ value: 'Didact Gothic', label: 'Didact Gothic' },
	{ value: 'DM Sans', label: 'DM Sans' },
	{ value: 'DM Serif Display', label: 'DM Serif Display' },
	{ value: 'Domine', label: 'Domine' },
	{ value: 'Dosis', label: 'Dosis' },
	{ value: 'EB Garamond', label: 'EB Garamond' },
	{ value: 'Eczar', label: 'Eczar' },
	{ value: 'Encode Sans', label: 'Encode Sans' },
	{ value: 'Exo', label: 'Exo' },
	{ value: 'Exo 2', label: 'Exo 2' },
	{ value: 'Faustina', label: 'Faustina' },
	{ value: 'Fira Sans', label: 'Fira Sans' },
	{ value: 'Fira Sans Condensed', label: 'Fira Sans Condensed' },
	{ value: 'Fjalla One', label: 'Fjalla One' },
	{ value: 'Francois One', label: 'Francois One' },
	{ value: 'Frank Ruhl Libre', label: 'Frank Ruhl Libre' },
	{ value: 'Fredoka One', label: 'Fredoka One' },
	{ value: 'Gelasio', label: 'Gelasio' },
	{ value: 'Gloria Hallelujah', label: 'Gloria Hallelujah' },
	{ value: 'Gothic A1', label: 'Gothic A1' },
	{ value: 'Great Vibes', label: 'Great Vibes' },
	{ value: 'Heebo', label: 'Heebo' },
	{ value: 'Hind', label: 'Hind' },
	{ value: 'Hind Madurai', label: 'Hind Madurai' },
	{ value: 'Hind Siliguri', label: 'Hind Siliguri' },
	{ value: 'IBM Plex Mono', label: 'IBM Plex Mono' },
	{ value: 'IBM Plex Sans', label: 'IBM Plex Sans' },
	{ value: 'IBM Plex Sans Arabic', label: 'IBM Plex Sans Arabic' },
	{ value: 'IBM Plex Sans Condensed', label: 'IBM Plex Sans Condensed' },
	{ value: 'IBM Plex Serif', label: 'IBM Plex Serif' },
	{ value: 'Inconsolata', label: 'Inconsolata' },
	{ value: 'Indie Flower', label: 'Indie Flower' },
	{ value: 'Inter', label: 'Inter' },
	{ value: 'Josefin Sans', label: 'Josefin Sans' },
	{ value: 'Jost', label: 'Jost' },
	{ value: 'Kalam', label: 'Kalam' },
	{ value: 'Kanit', label: 'Kanit' },
	{ value: 'Karla', label: 'Karla' },
	{ value: 'Kaushan Script', label: 'Kaushan Script' },
	{ value: 'La Belle Aurore', label: 'La Belle Aurore' },
	{ value: 'Lato', label: 'Lato' },
	{ value: 'Lexend', label: 'Lexend' },
	{ value: 'Lexend Deca', label: 'Lexend Deca' },
	{ value: 'Libre Baskerville', label: 'Libre Baskerville' },
	{ value: 'Libre Franklin', label: 'Libre Franklin' },
	{ value: 'Lobster', label: 'Lobster' },
	{ value: 'Lobster Two', label: 'Lobster Two' },
	{ value: 'Lora', label: 'Lora' },
	{ value: 'Luckiest Guy', label: 'Luckiest Guy' },
	{ value: 'M PLUS 1p', label: 'M PLUS 1p' },
	{ value: 'M PLUS Rounded 1c', label: 'M PLUS Rounded 1c' },
	{ value: 'Manrope', label: 'Manrope' },
	{ value: 'Marcellus', label: 'Marcellus' },
	{ value: 'Martel', label: 'Martel' },
	{ value: 'Maven Pro', label: 'Maven Pro' },
	{ value: 'Merriweather', label: 'Merriweather' },
	{ value: 'Merriweather Sans', label: 'Merriweather Sans' },
	{ value: 'Michroma', label: 'Michroma' },
	{ value: 'Montserrat', label: 'Montserrat' },
	{ value: 'Montserrat Alternates', label: 'Montserrat Alternates' },
	{ value: 'Mukta', label: 'Mukta' },
	{ value: 'Mulish', label: 'Mulish' },
	{ value: 'Nanum Gothic', label: 'Nanum Gothic' },
	{ value: 'Nanum Myeongjo', label: 'Nanum Myeongjo' },
	{ value: 'News Cycle', label: 'News Cycle' },
	{ value: 'Noticia Text', label: 'Noticia Text' },
	{ value: 'Noto Sans', label: 'Noto Sans' },
	{ value: 'Noto Sans Display', label: 'Noto Sans Display' },
	{ value: 'Noto Sans HK', label: 'Noto Sans HK' },
	{ value: 'Noto Sans JP', label: 'Noto Sans JP' },
	{ value: 'Noto Sans KR', label: 'Noto Sans KR' },
	{ value: 'Noto Sans SC', label: 'Noto Sans SC' },
	{ value: 'Noto Sans TC', label: 'Noto Sans TC' },
	{ value: 'Noto Serif', label: 'Noto Serif' },
	{ value: 'Noto Serif JP', label: 'Noto Serif JP' },
	{ value: 'Noto Serif TC', label: 'Noto Serif TC' },
	{ value: 'Nunito', label: 'Nunito' },
	{ value: 'Nunito Sans', label: 'Nunito Sans' },
	{ value: 'Old Standard TT', label: 'Old Standard TT' },
	{ value: 'Open Sans', label: 'Open Sans' },
	{ value: 'Orbitron', label: 'Orbitron' },
	{ value: 'Oswald', label: 'Oswald' },
	{ value: 'Outfit', label: 'Outfit' },
	{ value: 'Overpass', label: 'Overpass' },
	{ value: 'Oxygen', label: 'Oxygen' },
	{ value: 'Pacifico', label: 'Pacifico' },
	{ value: 'Passion One', label: 'Passion One' },
	{ value: 'Pathway Gothic One', label: 'Pathway Gothic One' },
	{ value: 'Patrick Hand', label: 'Patrick Hand' },
	{ value: 'Patua One', label: 'Patua One' },
	{ value: 'Paytone One', label: 'Paytone One' },
	{ value: 'Permanent Marker', label: 'Permanent Marker' },
	{ value: 'Philosopher', label: 'Philosopher' },
	{ value: 'Play', label: 'Play' },
	{ value: 'Playfair Display', label: 'Playfair Display' },
	{ value: 'Poppins', label: 'Poppins' },
	{ value: 'Prata', label: 'Prata' },
	{ value: 'Press Start 2P', label: 'Press Start 2P' },
	{ value: 'Prompt', label: 'Prompt' },
	{ value: 'Pt Mono', label: 'PT Mono' },
	{ value: 'Pt Sans', label: 'PT Sans' },
	{ value: 'Pt Sans Caption', label: 'PT Sans Caption' },
	{ value: 'Pt Sans Narrow', label: 'PT Sans Narrow' },
	{ value: 'Pt Serif', label: 'PT Serif' },
	{ value: 'Public Sans', label: 'Public Sans' },
	{ value: 'Quattrocento Sans', label: 'Quattrocento Sans' },
	{ value: 'Questrial', label: 'Questrial' },
	{ value: 'Quicksand', label: 'Quicksand' },
	{ value: 'Rajdhani', label: 'Rajdhani' },
	{ value: 'Raleway', label: 'Raleway' },
	{ value: 'Red Hat Display', label: 'Red Hat Display' },
	{ value: 'Righteous', label: 'Righteous' },
	{ value: 'Roboto', label: 'Roboto' },
	{ value: 'Roboto Condensed', label: 'Roboto Condensed' },
	{ value: 'Roboto Mono', label: 'Roboto Mono' },
	{ value: 'Roboto Slab', label: 'Roboto Slab' },
	{ value: 'Rokkitt', label: 'Rokkitt' },
	{ value: 'Rubik', label: 'Rubik' },
	{ value: 'Rubik Mono One', label: 'Rubik Mono One' },
	{ value: 'Russo One', label: 'Russo One' },
	{ value: 'Sacramento', label: 'Sacramento' },
	{ value: 'Saira', label: 'Saira' },
	{ value: 'Saira Condensed', label: 'Saira Condensed' },
	{ value: 'Sarabun', label: 'Sarabun' },
	{ value: 'Satisfy', label: 'Satisfy' },
	{ value: 'Sawarabi Mincho', label: 'Sawarabi Mincho' },
	{ value: 'Secular One', label: 'Secular One' },
	{ value: 'Shadows Into Light', label: 'Shadows Into Light' },
	{ value: 'Signika', label: 'Signika' },
	{ value: 'Signika Negative', label: 'Signika Negative' },
	{ value: 'Slabo 27px', label: 'Slabo 27px' },
	{ value: 'Sora', label: 'Sora' },
	{ value: 'Source Code Pro', label: 'Source Code Pro' },
	{ value: 'Source Sans Pro', label: 'Source Sans Pro' },
	{ value: 'Source Serif Pro', label: 'Source Serif Pro' },
	{ value: 'Space Grotesk', label: 'Space Grotesk' },
	{ value: 'Space Mono', label: 'Space Mono' },
	{ value: 'Spartan', label: 'Spartan' },
	{ value: 'Spectral', label: 'Spectral' },
	{ value: 'Staatliches', label: 'Staatliches' },
	{ value: 'Tajawal', label: 'Tajawal' },
	{ value: 'Teko', label: 'Teko' },
	{ value: 'Tinos', label: 'Tinos' },
	{ value: 'Titan One', label: 'Titan One' },
	{ value: 'Titillium Web', label: 'Titillium Web' },
	{ value: 'Ubuntu', label: 'Ubuntu' },
	{ value: 'Ubuntu Condensed', label: 'Ubuntu Condensed' },
	{ value: 'Unna', label: 'Unna' },
	{ value: 'Urbanist', label: 'Urbanist' },
	{ value: 'Varela Round', label: 'Varela Round' },
	{ value: 'Vollkorn', label: 'Vollkorn' },
	{ value: 'Work Sans', label: 'Work Sans' },
	{ value: 'Yanone Kaffeesatz', label: 'Yanone Kaffeesatz' },
	{ value: 'Yantramanav', label: 'Yantramanav' },
	{ value: 'Yellowtail', label: 'Yellowtail' },
	{ value: 'zilla-slab', label: 'Zilla Slab' },
];